export default "__VITE_ASSET__BGz$dY6I__"